import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: null,
};

const reportsSlice = createSlice({
    name: "reportData",
    initialState,
    reducers: {
        setReportData: (state, action) => {
            state.value = action.payload;
        },
        clearReportData: (state) => {
            state.value = null;
        },
    },
});

export const { setReportData, clearReportData } = reportsSlice.actions;
export default reportsSlice.reducer;
